module.exports = __webpack_public_path__ + "static/default_preview-b4f7da245a747e13fed2bd4a1a988c79.jpg";